import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "../assets/css/homeservicesclientscta.css";
import { icon } from "@fortawesome/fontawesome-svg-core";

const clients = [
  {
    name: "Mahindra & Mahindra Ltd",
    location: "MRV Chennai",
    industry: "Automotive Manufacturing",
    icon: require("../assets/images/logos/mahindra.png")
  },
  {
    name: "Turbo Energy P Ltd",
    location: "OMR Chennai",
    industry: "Energy Solutions",
    icon: require("../assets/images/logos/tel.png")
  },
  {
    name: "Stellar Optic P Ltd",
    location: "OMR Chennai",
    industry: "Optical Manufacturing",
    icon: require("../assets/images/logos/stellar.png")
  },
  {
    name: "Praba's Vcare Health Clinic",
    location: "Chennai",
    industry: "Healthcare",
    icon: require("../assets/images/logos/vcare.png")
  },
  {
    name: "VeCuRa Wellness Clinic",
    location: "Chennai",
    industry: "Healthcare & Wellness",
    icon: require("../assets/images/logos/vecura_logo_rated.png")
  },
  {
    name: "Epoch Living",
    location: "Chennai",
    industry: "Interior Design",
    icon: require("../assets/images/logos/Epoch.png")
  }
];

// const testimonials = [
//   {
//     name: "Dr. Rajesh Kumar",
//     role: "Facility Manager, VeCuRa Wellness",
//     content: "BCAS has been instrumental in maintaining optimal air quality in our medical facility. Their prompt service and expertise are commendable. The temperature control systems they installed have consistently performed excellently even during peak summer months.",
//     // image: "/api/placeholder/60/60",
//     rating: 5
//   },
//   {
//     name: "Priya Shankar",
//     role: "Operations Head, Stellar Optic",
//     content: "The team at BCAS provided excellent HVAC solutions for our manufacturing unit. Their attention to detail and professional approach sets them apart. We've seen a 30% reduction in energy costs since implementing their recommended systems.",
//     // image: "/api/placeholder/60/60",
//     rating: 5
//   },
//   {
//     name: "Arun Prakash",
//     role: "Project Director, Turbo Energy",
//     content: "We have been working with BCAS for over 5 years. Their service and technical expertise have been exceptional. Their preventive maintenance program has virtually eliminated unexpected downtime in our cooling systems.",
//     // image: "/api/placeholder/60/60",
//     rating: 4
//   }
// ];

const HomeServicesClientsCTA = () => {
  return (
    <>
      {/* Clients Section */}
      <section className="clients-section py-5">
        <Container>
          <div className="section-header text-center mb-5">
            <span className="badge rounded-pill mb-2">OUR CLIENTS</span>
            <h2 className="fw-bold">Trusted by Leading Organizations</h2>
            <p className="text-muted mx-auto section-description">
              We take pride in serving some of the most prestigious organizations across various industries,
              delivering reliable air conditioning solutions tailored to their specific requirements.
            </p>
          </div>

          <Row className="gy-4 ">
            {clients.map((client, index) => (
              <Col xs={6} sm={4} md={3} lg={2} key={index}>
                <Card className="client-card h-100 text-center border-0 shadow-sm">
                  <Card.Body className="d-flex flex-column align-items-center ">
                    <img src={client.icon} alt={client.name} className="client-icon mb-3 object-fit-contain w-100 " />
                    <Card.Title className="client-name">{client.name}</Card.Title>
                    <Card.Subtitle className="client-location mb-2">{client.location}</Card.Subtitle>
                    <Card.Text className="client-industry small">{client.industry}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {/* <div className="testimonial-container mt-5 pt-3">
            <h3 className="text-center fw-bold mb-4">What Our Clients Say</h3>
            <Swiper
              modules={[Pagination, Autoplay, EffectFade]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              effect="fade"
              fadeEffect={{ crossFade: true }}
              spaceBetween={30}
              slidesPerView={1}
              className="testimonial-slider"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <Card className="testimonial-card border-0 shadow h-100">
                    <Card.Body className="p-4 p-md-5">
                      <Row className="align-items-center">
                        <Col md={3} className="text-center text-md-start mb-4 mb-md-0">
                          {/* <div className="testimonial-avatar mb-3">
                            <img src={testimonial.image} alt={testimonial.name} className="rounded-circle" />
                          </div> 
                          <div className="testimonial-rating mb-2">
                            {[...Array(5)].map((_, i) => (
                              <i key={i} className={`bi bi-star-fill ${i < testimonial.rating ? 'text-warning' : 'text-muted'}`}></i>
                            ))}
                          </div>
                          <h5 className="testimonial-name mb-1">{testimonial.name}</h5>
                          <p className="testimonial-role text-muted small mb-0">{testimonial.role}</p>
                        </Col>
                        <Col md={9}>
                          <i className="bi bi-quote testimonial-icon"></i>
                          <Card.Text className="testimonial-content fst-italic fs-5">
                            "{testimonial.content}"
                          </Card.Text>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </div> */}
        </Container>
      </section>

      {/* CTA Section */}
      <section className="cta-section py-5 text-white text-center">
        <Container>
          <div className="cta-content py-4">
            <h2 className="fw-bold mb-3">Need Expert AC Solutions?</h2>
            <p className="lead mx-auto mb-4">
              Get professional air conditioning services for your business or residence.
              Our certified technicians are ready to provide customized cooling solutions.
            </p>
            <Row className="justify-content-center">
              <Col md={8} lg={6}>
                <div className="cta-features mb-4 d-flex justify-content-center flex-wrap">
                  <span className="cta-feature-badge"><i className="bi bi-check-circle-fill me-2"></i>Free Consultation</span>
                  <span className="cta-feature-badge"><i className="bi bi-check-circle-fill me-2"></i>Quick Response</span>
                  <span className="cta-feature-badge"><i className="bi bi-check-circle-fill me-2"></i>Competitive Pricing</span>
                </div>
              </Col>
            </Row>
            <div className="d-flex justify-content-center gap-3 mt-2 flex-wrap ">
              <a
                href={window.innerWidth <= 768 ? "tel:7358052100" : "https://wa.me/7358052100"}
                className="btn cta-button btn-lg fw-medium"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-telephone-fill me-2"></i>Contact Our Experts
              </a>

              <a href="/services" className="btn cta-secondary-button btn-lg fw-medium ">
                <i className="bi bi-info-circle-fill me-2"></i>Learn More
              </a>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default HomeServicesClientsCTA;